module.exports = __webpack_public_path__ + "img/machine.ede3cb51.svg";